// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"F4-z","inlineTitle":"G4-z","sponsoredAdsWrapper":"H4-z","marketplaceRecosWrapper":"I4-z","brandShopTheLookWrapper":"J4-z"};